export default __webpack_public_path__ + "static/article-1-911e0bf311710f08006187858e1233f6.jpg";